export const ARROW_RIGHT = 'ARROW_RIGHT'
export const ARROW_LEFT = 'ARROW_LEFT'
